export const resetForm = (formValues, initialValues) => {
  Object.entries(initialValues).forEach(([key, value]) => {
    formValues.set(key, value);
  });
};
